import { ChainId, testnetAddresses } from '@endure/chains';

import type { Token } from 'types';
import type { Address } from 'viem';
import { WALPHA_WRAPPER_TOKENS } from './bittensorWrappers';

export const WALPHA_FALLBACK_TOKENS: readonly Token[] =
  WALPHA_WRAPPER_TOKENS[ChainId.BITTENSOR_TESTNET] ?? [];

// Stash-faucet routing is keyed by chain (mirrors WSTAO_WRAPPER_ADDRESSES) so a
// colliding token address on another dev chain (e.g. LOCAL 31337) is never
// routed to the Bittensor-testnet WAlphaStashFaucet contract.
export const STASH_FAUCET_WALPHA_TOKEN_ADDRESSES: Partial<Record<ChainId, readonly Address[]>> = {
  [ChainId.BITTENSOR_TESTNET]: WALPHA_FALLBACK_TOKENS.map((token) => token.address),
};

export const STASH_FAUCET_TOKEN_ADDRESSES: Partial<Record<ChainId, readonly Address[]>> = {
  [ChainId.BITTENSOR_TESTNET]: [
    testnetAddresses.wsTAO,
    ...(STASH_FAUCET_WALPHA_TOKEN_ADDRESSES[ChainId.BITTENSOR_TESTNET] ?? []),
  ],
};
